export const PUSH_LABEL_PREFIX = 'Push(s) effectué(s) :';
